export const GET_CST_GROUP = 'GET_CST_GROUP'
export const GET_SINGLE_CST = 'GET_SINGLE_CST'
export const LOAD_MORE_CST_GROUP = 'LOAD_MORE_CST_GROUP'
export const ADD_CST_GROUP = 'ADD_CST_GROUP'
export const EDIT_CST_GROUP = 'EDIT_CST_GROUP'
export const RESET_STATUS = 'RESET_STATUS'
export const RESET_VALUE = 'RESET_VALUE'
export const VALIDATE_CHARGE_CODE = 'VALIDATE_CHARGE_CODE'
